import { render } from "./CollapseComponent.vue?vue&type=template&id=e7dfb4d6"
import script from "./CollapseComponent.vue?vue&type=script&lang=js"
export * from "./CollapseComponent.vue?vue&type=script&lang=js"

import "./CollapseComponent.vue?vue&type=style&index=0&id=e7dfb4d6&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__